import { render } from "./Home.vue?vue&type=template&id=6b432438&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6b432438&scoped=true&lang=css"

import exportComponent from "/Users/alanmateu/Documents/app-dec/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b432438"]])

export default __exports__